import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
  width?: string;
}

const CourseModuleIcon: React.FC<CustomIconProps> = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='bxs-videos'>
      <path
        id='Vector'
        d='M4 8H2V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H16V20H4V8Z'
        fill='#F9F9FA'
      />
      <path
        id='Vector_2'
        d='M20 2H8C7.46957 2 6.96086 2.21071 6.58579 2.58579C6.21071 2.96086 6 3.46957 6 4V16C6 16.5304 6.21071 17.0391 6.58579 17.4142C6.96086 17.7893 7.46957 18 8 18H20C20.5304 18 21.0391 17.7893 21.4142 17.4142C21.7893 17.0391 22 16.5304 22 16V4C22 3.46957 21.7893 2.96086 21.4142 2.58579C21.0391 2.21071 20.5304 2 20 2ZM11 14V6L18 10L11 14Z'
        fill='#F9F9FA'
      />
    </g>
  </svg>
);

export default CourseModuleIcon;
